export default __webpack_public_path__ + "static/media/logo_sigue_latiendo_blanco.b98a7632.svg";